export default __webpack_public_path__ + "static/Element_Dust-70c49e9326101011eff45dcdf8fe7ec4.png";